import './PageHeader.scss';

import { string } from 'prop-types';
import React from 'react';

export const PageHeader = ({
  className = '',
  title = 'Accounts',
  children,
  titleClassName = ''
}) => {
  return (
    <div className={`page-header ${className}`}>
      <div className={`page-header-title ${titleClassName}`}>{title}</div>
      <div className="page-header-inline-content">{children}</div>
    </div>
  );
};

PageHeader.propTypes = {
  title: string
};
